import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

/**
 * Attaches an Accept-Language header to every outgoing HTTP request so that
 * the backend can return translated messages in the user's active language.
 *
 * The locale is read from TranslateService, which is the single source of
 * truth for the active language in the application.
 */
@Injectable()
export class LocaleInterceptor implements HttpInterceptor {

  constructor(private translateService: TranslateService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const lang = this.translateService.currentLang
      ?? this.translateService.defaultLang
      ?? 'fr';

    const localeRequest = request.clone({
      headers: request.headers.set('Accept-Language', lang),
    });

    return next.handle(localeRequest);
  }
}
